import { createApp } from 'vue'
import App from './App.vue'
import "./utils/rem";

createApp(App).mount('#app')
